import React, { useCallback } from 'react';
import Table from '../common/Table/Table';
import EditButton from '../common/ActionButton/EditButton';
import DeleteButton from '../common/ActionButton/DeleteButton';
import CopyButton from '../common/ActionButton/CopyButton';
import DownloadButton from '../common/ActionButton/DownloadButton';
import { mapInvoiceType } from './invoiceHelpers';
import { deleteEntity } from '../../utlis/deleteEntity';
import '../../style/PageTable.css';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const InvoiceListTable = ({ invoices, onEdit, onView, onCopy, onDelete, onDownload, onRowClick, refreshInvoices }) => {

  const deleteInvoice = async (invoiceId, e) => {
    await deleteEntity({
      entityType: 'invoices',
      entityId: invoiceId,
      event: e,
      onDeleted: refreshInvoices
    });
  };

  const renderRow = useCallback((inv) => (
    <>
    <td>{inv.id}</td>
      <td>{inv.invoice_no}</td>
      <td>{mapInvoiceType(inv.invoice_type)}</td>
      <td>{formatDate(inv.invoice_date)}</td>
      <td>{inv.name}</td>
      {/* <td>{inv.Taxable_amt}</td> */}
      <td>{inv.Total_amt}</td>
      <td>{inv.Paid_Amt}</td>
      <td>{inv.GST_no}</td>
      <td>{inv.email}<br />{inv.phone_no}</td>
      <td className="actions-cell">
        <div className="action-buttons">
          <EditButton className="lead-edit-btn" title="Invoice Edit" onClick={(e) => { e.stopPropagation(); onEdit(inv); }} />
          <CopyButton className="copy-btn" title="Invoice Copy" onClick={(e) => { e.stopPropagation(); onCopy(inv); }} />
          <DeleteButton 
            className="delete-btn" 
            title="Invoice Delete" 
            onClick={(e) => deleteInvoice(inv.id, e)}
 />
          <DownloadButton className="download-btn" title="Invoice Download" onClick={(e) => { e.stopPropagation(); onDownload(inv); }} />
        </div>
      </td>
    </>
  ), [onEdit, onView, onCopy, onDelete, onDownload, deleteInvoice]);

  const columns = [
    { header: 'ID', style: { maxWidth: '50px', width: '50px' } },
    { header: 'Invoice No', style: { maxWidth: '110px', width: '110px' } },
    { header: 'Type', style: { maxWidth: '50px', width: '50px' } },
    { header: 'Date', style: { maxWidth: '80px', width: '80px' } },
    { header: 'Name', style: { maxWidth: '160px', width: '160px' } },
    // { header: 'Taxable Amount' },
    { header: 'Total Amt', style: { maxWidth: '70px', width: '70px' } },
    { header: 'Paid Amt', style: { maxWidth: '70px', width: '70px' } },
    { header: 'GST No', style: { maxWidth: '100px', width: '100px' } },
    { header: 'Contact Info', style: { maxWidth: '150px', width: '150px' } },
    { header: 'Actions', className: 'actions-header', style: { maxWidth: '75px', width: '75px' } }
  ];

  return (
    <Table
      columns={columns}
      data={invoices}
      renderRow={renderRow}
      className="page-table"
      onRowClick={onRowClick}
    />
  );
};

export default InvoiceListTable;
